import { useRemoveTag, useTrackWithUser } from '@ion/api';

export default function useDeleteTag({ tag, onClose }) {
  const [trackTagDeleted] = useTrackWithUser('pipeline_tag_deleted');
  const [removeTag] = useRemoveTag({
    onCompleted: () => {
      trackTagDeleted();
      onClose();
    },
  });

  const onConfirm = () => {
    return removeTag({ tag });
  };

  return { onConfirm };
}
